import getInitial from 'owa-persona/lib/utils/getInitial';
import getTextBoyColor from 'owa-persona/lib/utils/getTextBoyColor';
import PersonaPostalAddress from 'owa-service/lib/contract/PersonaPostalAddress';
import { getLocalizedAddress } from './getLocalizedAddress';
import { LocationPersonaControlViewState } from '../data/schema/LocationPersonaControlViewState';

/**
 * Create a Persona for postal addresses to show them as resolved entities
 * @param postalAddress: the location's postal address
 * @param locationName: location displayName
 */
export default function createLocationPersonaFromPostalAddress(
    postalAddress: PersonaPostalAddress,
    locationName: string
): LocationPersonaControlViewState {
    return {
        displayName: locationName,
        postalAddress: postalAddress,
        displayAddress: getLocalizedAddress(postalAddress),
        initials: getInitial(locationName),
        textBoyColor: getTextBoyColor(locationName),
        selectionSource: 'LocationWell',
        personaType: 'Unknown',
        personaControlId: locationName,
    };
}
